import { landingPageForm } from '@passion/types';

export const checkInterface = (obj: any): obj is landingPageForm => {
  return Array.isArray(obj.channel);
};
